import React from 'react'

import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useNavigate, useLocation } from 'react-router-dom'

import { SideBarSelection } from '../../../utils/Type'

const drawerWidth = 240

interface SideBarProps {
  sideBarSelections: SideBarSelection[]
}

export default function SideBar({ sideBarSelections }: SideBarProps) {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const currentPath = location.pathname

  const mediumSreen = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [isClosing, setIsClosing] = React.useState(false)

  const handleDrawerClose = () => {
    setIsClosing(true)
    setMobileOpen(false)
  }

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false)
  }

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen)
    }
  }

  const handleSelection = (path: string) => {
    setMobileOpen(false)
    navigate(path)
  }

  const drawer = (
    <List>
      {sideBarSelections.map((selection, index) => (
        <ListItem key={index} disablePadding>
          <ListItemButton
            style={{
              height: '58px',
              background:
                selection.path === currentPath
                  ? '#C4BBE7'
                  : 'linear-gradient(135deg, #add8e6, #ffb6c1)'
            }}
            onClick={() => handleSelection(selection.path)}
          >
            <ListItemIcon>
              <Icon
                className="material-icons"
                sx={{ height: '1.5rem', width: '1.5rem', fontSize: '1.5rem' }}
              >
                {selection.icon}
              </Icon>
            </ListItemIcon>
            <ListItemText primary={selection.name} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  )

  if (mediumSreen) {
    return (
      <Box>
        <AppBar
          style={{
            height: '60px',
            display: 'flex',
            background: 'linear-gradient(135deg, #add8e6, #ffb6c1)'
          }}
        >
          <Toolbar sx={{ width: 1, paddingLeft: '24px !important' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              background: 'linear-gradient(135deg, #FFF4B8, #FFF2D1)'
            }
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    )
  }

  return (
    <Box sx={{ width: '240px' }}>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            background: 'linear-gradient(135deg, #FFF4B8, #FFF2D1)'
          }
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  )
}
